










// Vue
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { mapGetters } from 'vuex';
import { Mixins } from 'vue-mixin-decorator';

// Constants
import Assets from '@/constants/assets.ts';

// Components
import Btn, {
  BtnColor,
  BtnWidth,
  BtnHeight,
  BtnFontSize,
  BtnPredefinedStyle,
} from '@/shared/components/btn.component.vue';
import Input, {
  InputType,
  InputStyle,
} from '@/shared/components/input.component.vue';

// Mixins
import ErrorMixin from '@/shared/mixins/error.mixin';

// Services
import UtilsService from '@/core/services/utils.service';
import BudgetService from '@/manager/budget/budget.service';

@Component({
  components: {
    Btn,
    Input,
  },
  computed: {
    ...mapGetters({
      currentBudget: 'getCurrentBudgetMandate',
    }),
  },
})
export default class NifValidation extends Mixins<ErrorMixin>(ErrorMixin) {
  @Prop() private id!: string;
  @Prop({ default: false }) private squared!: boolean;

  private assets = Assets;
  private inputType = InputType;
  private btnColor = BtnColor;
  private btnPredefinedStyle = BtnPredefinedStyle;
  private btnFontSize = BtnFontSize;
  private btnWidth = BtnWidth;
  private btnHeight = BtnHeight;
  private currentBudget!: any;
  private nif = '';
  private nifMask = '';
  private literals = {
    title: 'Firma del mandato SEPA',
    subtitle:
      'Con la firma del mandato SEPA, autorizas a <span style="font-weight: 600;">Level Up</span> a ' +
      'iniciar los cobros por domiciliación en la cuenta indicada en la aceptación del alta.',
    subtitleInput: 'Introduce tus datos para validar tu identidad:',
    inputNif: {
      label: 'NIF',
      placeholder: '12345678A',
    },
    btn: 'Validar',
  };

  @Watch('nif')
  private watchNif(newVal: string, oldVal: string) {
    this.nifMask = UtilsService.setNifMask(newVal, this.nifMask);
  }

  private emitNifValidated() {
    this.$emit('nif-validated');
  }

  private setServerError(err: any) {
    this.error = { ...err.response.data };
  }

  private validateNif() {
    BudgetService.validateBudgetNif(this.id, this.nif).then(
      (res) => {
        this.emitNifValidated();
      },
      (err) => {
        this.setServerError(err);
      },
    );
  }
}
